<template>
	<div class="zoom">
  		<div class="photo1" ref="photo" v-parallax-fit="photo1"></div>
  	</div>
</template>

<script>
export default {
  name: 'slide30',
  data() {
    return {
      photo1: [
        {
          start: 39500,
          end: 40000,
          fromStyle: { transform: 'translateY(-1000px)' },
          toStyle: { transform: 'translateY(260px)' }
        },
        {
          start: 40300,
          end: 40900,
          fromStyle: { transform: 'translateY(260px)' },
          toStyle: { transform: 'translateY(1800px)' }
        },
      ],
    };
  }
}
</script>

<style lang="scss" scoped>
.photo1 {
    position: fixed;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/30_FriendsGroup.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 530px;
    height: 630px;
    transition: 0.3s;
    transform-origin: center;
    z-index: 5;
    left: calc(50% - 266px);
    top: 22vh;
    @media(min-width: 600px) and (max-width: 1280px) {
      top: 0;
      zoom: 0.65;
    }
    @media(max-width: 600px) {
      left: calc(50% - 116px);
      width: 220px;
      height: 420px;
    }
    @media(max-width: 400px) {
      left: calc(50% - 86px);
      width: 190px;
      height: 200px;
      top: -30px;
    }
}
</style>
